/* import __COLOCATED_TEMPLATE__ from './tab-content.hbs'; */
import Component from '@ember/component';

export default class TabContent extends Component {
    tagName = '';
}
